export default __webpack_public_path__ + "static/media/Resources.3c3bef32.svg";